import Vue from "vue";
import { Plugin as Fragment } from "vue-fragment";

export default Vue.use(Fragment);
